import { observable, action } from 'mobx';
import { computedFn } from 'mobx-utils';
import { RootStore, EDITOR_STORE } from 'store';
import { SpriteFrameSize, Sprite, spriteFrameSize } from 'utilities';
import { getStyleAttr, getImage } from './utils';

export const EDITOR_SPRITE_FRAMES_STORE = 'EDITOR_SPRITE_FRAMES_STORE';

export class EditorSpriteFramesStore {
  @observable loadedImages: { [url: string]: HTMLImageElement } = {};

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable styleAttrs = computedFn((frameNumber: number, size: SpriteFrameSize) => {
    const { project } = this.rootStore[EDITOR_STORE];
    // console.log({ project });
    const originalUrl = Sprite.getUrl(frameNumber, project, size);

    if (this.isImageLoaded(originalUrl)) {
      return getStyleAttr(frameNumber, project, size);
    }

    this.loadImage(originalUrl);
    return getStyleAttr(frameNumber, project, size === spriteFrameSize.l ? spriteFrameSize.s : size);
  });

  private isImageLoaded = url => {
    return !!this.loadedImages[url];
  }

  private loadImage = url => {
    getImage(url)
      .then(this.setLoadedImage)
      .catch(console.error);
  }

  @action.bound setLoadedImage({ url, img }: { url: string, img: HTMLImageElement }) {
    this.loadedImages[url] = img;
  }

  @action.bound clearLoadedImages() {
    this.loadedImages = {};
  }
}
